export const BASE_URL = process.env.SEVEN_DATA_REST_API_URL || "http://10.210.0.144:3030";
// export const BASE_URL = process.env.SEVEN_DATA_REST_API_URL || 'http://localhost:3030';
